import * as loadjs from 'loadjs'
import { getQueryParam } from '../helpers/getQueryParam'
import { LoadJsBundle } from '../enums/LoadJsBundle'
import Logger from '../helpers/Logger'

const GROW_FAVES_URL = 'https://faves.grow.me'

export default class GrowFaves {
  constructor() {
    let favesUrl = `${GROW_FAVES_URL}/main.js`

    // Load Grow Faves if query parameter exists
    const growVersion = getQueryParam('growFavesVersion')
    const growFavesAccountId = getQueryParam('growFavesAccountId') as string
    const growFavesSiteId = getQueryParam('growFavesSiteId') as string

    if (growVersion) {
      favesUrl = `${GROW_FAVES_URL}/main.${growVersion}.js`
    }

    if (growFavesAccountId && growFavesSiteId) {
      loadjs(favesUrl, LoadJsBundle.growFaves, {
        before: function(path, scriptEl: HTMLScriptElement) {
          // Set attributes on the growFave script tag.
          scriptEl.setAttribute('data-grow-faves-site-id', growFavesSiteId)
          scriptEl.setAttribute(
            'data-grow-faves-account-id',
            growFavesAccountId
          )
        }
      })
    } else {
      Logger.debug(
        'ERROR: both ?growFavesAccountId and ?growFavesSiteId must be specified to load GrowFaves'
      )
    }
  }
}
